import { useSyncExternalStore } from 'react'
import { RoomEvent } from '../../constants/enums'
import { pubSubRoom } from '../../state/pubSub'
import { ROOMSTATE } from '../../state/state.rooms'
import { useUserSelector } from './useUser'

const getRoomsRestored = () => ROOMSTATE.restored
export const getPinnedRooms = () => ROOMSTATE.pinnedRooms
export const getPinnedRoomCount = () => ROOMSTATE.pinnedRooms.length
export const getIsRoomPinned = (id: number) => () =>
    !id ? false : ROOMSTATE.pinnedRooms.includes(id)
export const getPinHelperID = () => ROOMSTATE.pinHelperID

const subPinnedRooms = (callback: () => void) =>
    pubSubRoom.on(RoomEvent.PIN_ROOM, callback)
const subPinHelperID = (callback: () => void) =>
    pubSubRoom.on(RoomEvent.PIN_HELPER_ID, callback)
const subRestored = (callback: () => void) =>
    pubSubRoom.on(RoomEvent.RESTORED, callback)

export const useRoomRestored = () => {
    return useSyncExternalStore(subRestored, getRoomsRestored, getRoomsRestored)
}

export const usePinnedRooms = () => {
    const pinnedRooms = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRooms,
        getPinnedRooms,
    )

    return pinnedRooms
}
export const useIsRoomPinned = (id: number) => {
    const isRoomPinned = useSyncExternalStore(
        subPinnedRooms,
        getIsRoomPinned(id),
        getIsRoomPinned(id),
    )

    return isRoomPinned
}
export const usePinnedRoomCount = () => {
    const pinnedRoomCount = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRoomCount,
        getPinnedRoomCount,
    )

    return pinnedRoomCount
}
export const usePinHelperUser = () => {
    const pinHelperID = useSyncExternalStore(
        subPinHelperID,
        getPinHelperID,
        getPinHelperID,
    )
    const isFriend = useUserSelector(pinHelperID, 'isFriend')
    const isBookmark = useUserSelector(pinHelperID, 'isBookmark')
    return { id: pinHelperID, isFriend, isBookmark }
}
